import { ISharedLoadingProgressPresentation } from '../../../shared/shared-models/loading/shared-loading-progress.interface';

export const STOCK_TAKE_POPULATION_PROGRESS_TOTAL_STEPS = 3;

export const STOCK_TAKE_POPULATION_PROGRESS_STEP_LABELS: string[] = [
  'Create stock take',
  'Find matching items',
  'Add items to stock take',
];

export type StockTakePopulationProgressStep = 1 | 2 | 3;

/**
 * Build step-based loading presentation for stock take creation and item population.
 */
export function buildStockTakePopulationProgress(
  step: StockTakePopulationProgressStep,
  message: string,
): ISharedLoadingProgressPresentation {
  return {
    step,
    totalSteps: STOCK_TAKE_POPULATION_PROGRESS_TOTAL_STEPS,
    message,
    stepLabels: [...STOCK_TAKE_POPULATION_PROGRESS_STEP_LABELS],
  };
}
